// extracted by mini-css-extract-plugin
export default {"noDataText":"EndDataSearchResults_noDataText__cMILG"};